exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media1[data-v-02989422]{padding-top:15px;padding-bottom:15px;border-bottom:1px solid hsla(0,0%,86%,.5)}.is-total[data-v-02989422]{border-bottom:10px solid hsla(0,0%,86%,.5);border-top:9px solid hsla(0,0%,86%,.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02989422","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registrar/Estructura.vue
// module id = 500
// module chunks = 0